import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { getInitialVisitInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getInitialVisitInformationQueryFunction';
import {
  VisitInformationResponseType,
  VisitInformationTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';
import { getVisitInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getVisitShowInformationQueryOption = (
  params: VisitInformationTypeParams,
) =>
  queryOptions({
    queryKey: ['get_vehicle_damage_amount', params, params?.type],
    queryFn: () => {
      if (params?.type === 'initial') {
        return getInitialVisitInformationQueryFunction(params);
      }
      return getVisitInformationQueryFunction(params);
    },
    select: (data: VisitInformationResponseType) => {
      return {
        visitInformation: [
          {
            label: 'تاریخ بازدید :',
            value: data?.visit_date
              ? convertTimestampToShamsi(+data?.visit_date)
              : '',
          },
          { label: 'ساعت بازدید :', value: data?.visit_time?.toString() ?? '' },
          {
            label: 'تعداد بازدید :',
            value: data?.visit_number?.toString() ?? '',
          },
          {
            label: 'محل بازدید :',
            value: data?.visit_site?.fa_const?.toString() ?? '',
          },
          { label: 'مسافت طی شده :', value: data?.distance?.toString() ?? '' },
          {
            label: 'طول تعمیر :',
            value: data?.parts_repair_length?.toString() ?? '',
          },
          {
            label: 'آدرس محل بازدید :',
            value: data?.visit_location?.toString() ?? '',
          },
        ],
      };
    },
  });
export default getVisitShowInformationQueryOption;
